<template>
    <rounded-container variant="dark">
        <template v-slot:title>
            Monthly money-in vs holdings ({{ market }})
        </template>

        <div v-if="loading" class="p-3 text-center text-secondary">
            Loading...
        </div>
        <div v-else-if="!history.length" class="p-3 text-center text-secondary">
            No history available yet.
        </div>
        <bar-chart
            v-else
            :key="market"
            :chart-data="chartData"
            :chart-options="chartOptions"
            :styles="{ position: 'relative', padding: '10px', height: '300px' }"
        />
    </rounded-container>
</template>

<script>
import api from '@/mixins/api';
import RoundedContainer from '@/components/style/RoundedContainer.vue';
import BarChart from '@/components/charts/BarChart.vue';
import { CHART_COLOR_BUY, CHART_COLOR_SELL } from '@/constants/ui';

export default {
    name: 'PortfolioHistoricalValue',
    mixins: [api],
    components: { RoundedContainer, BarChart },
    props: {
        market: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            history: [],
        };
    },
    computed: {
        chartData() {
            return {
                labels: this.history.map(entry => entry.month),
                datasets: [
                    {
                        label: 'Money in',
                        backgroundColor: CHART_COLOR_BUY,
                        data: this.history.map(entry => entry.money_in),
                    },
                    {
                        label: 'Holdings value',
                        backgroundColor: CHART_COLOR_SELL,
                        data: this.history.map(entry => entry.holdings_value),
                    },
                ],
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    mode: 'index',
                    intersect: false,
                },
                scales: {
                    yAxes: [{
                        ticks: { beginAtZero: true },
                    }],
                },
            };
        },
    },
    watch: {
        market: {
            immediate: true,
            handler() {
                this.fetchHistory();
            },
        },
    },
    methods: {
        async fetchHistory() {
            this.loading = true;
            const response = await this.apiGet(`/api/portfolio/monthly_history?market=${this.market}`);
            if (!response) {
                this.loading = false;
                return;
            }
            this.history = response.data.history || [];
            this.loading = false;
        },
    },
};
</script>
